// removed by extract-text-webpack-plugin
module.exports = {"root":"LoginForm__root__3yovf","password":"LoginForm__password__35l8o","bottomWrapper":"LoginForm__bottomWrapper__3gUWm","recoveryLink":"LoginForm__recoveryLink__1OrfI","signupLink":"LoginForm__signupLink__1O_Q7","signupLinkInfo":"LoginForm__signupLinkInfo__2fNgK"};


//////////////////
// WEBPACK FOOTER
// ./src/forms/LoginForm/LoginForm.css
// module id = 1722
// module chunks = 0